module.exports = __webpack_public_path__ + "static/img/code_icon.24a9e36a.png";